<div class="container" style="height: 100%;padding:24px">

<!-- Top bar -->
<mat-toolbar class="topBar">

  <span class="spacer">
    Gear - {{currentScreen}}
  </span>

  <!-- Add Gear -->
  <button mat-mini-fab
          *ngIf="currentScreen === 'List'"
          class="blue-icon-button"
          type="button"
          matTooltip="Add Gear"
          matTooltipPosition="below"
          (click)="addNewGear()">
    <mat-icon>
      add
    </mat-icon>
  </button>

  <!-- Delete Gear -->
  <button mat-mini-fab
          *ngIf="currentScreen.slice(0,6) === 'Detail'"
          class="bottom-toolbar-button"
          type="button"
          matTooltip="Delete Gear"
          matTooltipPosition="below"
          (click)="deleteGear()">
    <mat-icon>
      delete
    </mat-icon>
  </button>
</mat-toolbar>

<br>

<div *ngIf="currentScreen === 'List'" class="gear-list">

  @for (gear of dataSync.user_gear(); track gear; let ind=$index;) {
    <div class="row">
      <mat-card matRipple [ngClass]="ind === selectedGear ? 'card-selected' : 'card-normal'" (click)="selectGear(ind)" style="padding:16px; font-size: 16px">
        {{gear}}
      </mat-card>
    </div>
    <br>
  }

  <!-- Cancel, delete or choose set -->
  <div class="row justify-content-between" align="center" style="margin-top: auto;">
    <button mat-stroked-button
            class="text-button"
            type="button"
            aria-label="cancel"
            (click)="onNoClick()">
      Cancel
    </button>

    <button mat-stroked-button
            class="text-button"
            type="submit"
            aria-label="confirm"
            (click)="confirmCurrentGear()">
      OK
    </button>
  </div>

</div>


<!-- Select gear type -->
<app-gear-type-dialog *ngIf="currentScreen === 'Type'"
                      [selectedGFType]="selectedType"
                      [selectedFishery]="selectedFishery"
                      [gearName]="currGearName"
                      (goBack)="goBack()"
                      (changeScreen)="fromTypeScreen($event)">

</app-gear-type-dialog>


<!-- Right now have a row of buttons on each gear form template, can cut repetition by putting it here. Do that later -->

<!-- Pot -->
<div *ngIf="currentScreen === 'Detail-Pot'" class="container" style="display: flex; flex-direction: column; height: 100%;">

    <app-pot-form style="display: flex; flex-direction: column; height: 100%;"
                  [pot]="selectedPot"
                  [potTypes]="potTypes"
                  [isEdit]="!isNew"
                  (cancelEvent)="cancelButtonClick($event)"
                  (gearAddEvent)="newGear($event)">

    </app-pot-form>

</div>

<!-- Longline -->
<div *ngIf="currentScreen === 'Detail-Longline'" class="container">

    <app-longline-form [line]="selectedLine"
                       [types]="longlineTypes"
                       [isEdit]="!isNew"
                       (cancelEvent)="cancelButtonClick($event)"
                       (gearAddEvent)="newGear($event)">

    </app-longline-form>

</div>

<!-- Pelagic -->
<div *ngIf="currentScreen === 'Detail-Pelagic'" class="container">

    <app-pelagic-form [pel]="selectedPelagic"
                      [types]="pelagicTypes"
                      [isEdit]="!isNew"
                      (cancelEvent)="cancelButtonClick($event)"
                      (gearAddEvent)="newGear($event)">

    </app-pelagic-form>

</div>
</div>
